module.exports = __webpack_public_path__ + "img/globe.e5ea4f06.png";